import * as Sentry from '@sentry/vue';
import router from '@/router';

import {getAppParams} from '@zettant/commonUtils';

export default ({ app }) => {
  if (!getAppParams().envParams.sentryDSN) return;
  Sentry.init({
    app,
    dsn: getAppParams().envParams.sentryDSN,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ['localhost', getAppParams().projectName, /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
  (window as any).Sentry = Sentry;
};
